import type { SVGProps } from "react";
const SvgWorkoutRun = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.25}
      d="M14.167 3.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="m12.5 17.5-.553-2.18a4.1 4.1 0 0 0-1.096-1.906l-1.268-1.248M5 9.294c.833-1.642 2.115-2.593 5-2.627m0 0c.182-.002.454-.003.725-.003.42 0 .63 0 .799.079.167.078.339.283.683.694.098.118.2.223.293.293M10 6.667 8.942 8.3c-.581.897-.872 1.346-.883 1.817-.005.21.03.418.102.615.163.442.583.773 1.422 1.435M12.5 7.73c.962.722 2.469 1.013 4.167-.898M12.5 7.73l-2.917 4.436M3.333 14.775l.565.135c1.44.342 2.938-.313 3.602-1.577"
    />
  </svg>
);
export default SvgWorkoutRun;
